export const isMobile = window.innerWidth < 500
